import React, { useState, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import "./styles/globals.css"
import { DashboardHeader } from "./components/dashboard-header"
import { OrgTeamSelector } from "./components/org-team-selector"
import { OrgOverview } from "./components/org-overview"
import { IntegrationsBoard } from "./components/integrations-board"
import { WorkTopicSnapshot } from "./components/work-topic-snapshot"
import { EmotionalHeatmap } from "./components/emotional-heatmap"
import { TimelineChart } from "./components/timeline-chart"
import { AIQAPanel } from "./components/ai-qa-panel"
import { NotificationsFeed } from "./components/notifications-feed"
import { GlobalNavigation } from "./components/global-navigation"
import { GovernancePage } from "./components/governance-page"
import { IntelligenceContainer } from "./components/intelligence-container"
import { TeamSettings } from "./components/team-settings"
import { getUser } from "../api/helpers"
import { setUserData } from "../auth/authActions"

export function OrgEqDashboard() {
  const [selectedOrganization, setSelectedOrganization] = useState("entire")
  const [selectedTracker, setSelectedTracker] = useState("all")
  const dispatch = useDispatch()
  const user = useSelector((state: any) => state.auth.user)

  // Load user data if not already loaded
  useEffect(() => {
    const loadUserData = async () => {
      console.log("🔍 OrgEqDashboard - Current user state:", user)
      console.log("🔍 OrgEqDashboard - Has organization_info?", !!user?.organization_info)
      console.log("🔍 OrgEqDashboard - Organization ID:", user?.organization_info?._id)
      
      if (!user || !user.organization_info) {
        console.log("🔄 OrgEqDashboard - Loading user data for org-eq...")
        try {
          const userData = await getUser(dispatch)
          console.log("🔍 OrgEqDashboard - getUser() response:", userData)
          if (userData?.user) {
            dispatch(setUserData(userData.user))
            console.log("✅ OrgEqDashboard - User data loaded successfully")
            console.log("✅ OrgEqDashboard - Organization ID:", userData.user?.organization_info?._id)
            console.log("✅ OrgEqDashboard - Full user object:", userData.user)
          }
        } catch (error) {
          console.error("❌ OrgEqDashboard - Failed to load user data:", error)
        }
      } else {
        console.log("✅ OrgEqDashboard - User data already loaded")
        console.log("✅ OrgEqDashboard - Organization ID:", user.organization_info._id)
      }
    }
    loadUserData()
  }, [])

  const dashboardContent = (
    <>
      <DashboardHeader onOrganizationChange={setSelectedOrganization} onTrackerChange={setSelectedTracker} />

      <main className="container mx-auto px-6 py-8 space-y-8">
        {/* Org/Team Selector */}
        <OrgTeamSelector />
        {/* Notifications Feed */}
        <NotificationsFeed organizationFilter={selectedOrganization} trackerFilter={selectedTracker} />
        {/* Organization Overview */}
        <OrgOverview selectedOrganization={selectedOrganization} selectedTracker={selectedTracker} />
        {/* Work Topic Snapshot */}
        <WorkTopicSnapshot organizationFilter={selectedOrganization} trackerFilter={selectedTracker} />
        {/* Main Content Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* Left Column - Heatmap and Timeline */}
          <div className="lg:col-span-2 space-y-8">
            <EmotionalHeatmap organizationFilter={selectedOrganization} trackerFilter={selectedTracker} />
            <TimelineChart organizationFilter={selectedOrganization} trackerFilter={selectedTracker} />
          </div>

          {/* Right Column - AI Q&A */}
          <div className="space-y-8">
            <AIQAPanel organizationFilter={selectedOrganization} trackerFilter={selectedTracker} />
          </div>
        </div>
      </main>
    </>
  )

  const integrationsContent = (
    <>
      <IntegrationsBoard />
    </>
  )

  const intelligenceContent = (
    <>
      <IntelligenceContainer />
    </>
  )

  const teamContent = (
    <>
      <TeamSettings />
    </>
  )

  return (
    <div className="org-eq-dashboard bg-white text-slate-900 min-h-screen">
      <GlobalNavigation
        governanceContent={<GovernancePage />}
        integrationsContent={integrationsContent}
        intelligenceContent={intelligenceContent}
        teamContent={teamContent}
      >
        {dashboardContent}
      </GlobalNavigation>
    </div>
  )
}